import type { Catalog } from "../../en";

/** Filipino: platform admin ai-models screen (mirrors en). */
export const aiModels: Catalog["adminScreens"]["aiModels"] = {
  title: "Mga AI provider at model",
  subtitle: "LLM gateway, embeddings, rerankers, guardrails at semantic cache na ginagamit ng lahat ng tenant.",
  changeHistory: "Kasaysayan ng pagbabago",
  addProvider: "Magdagdag ng provider",
  addProviderUnavailable: "Hindi pa puwedeng magdagdag ng provider — sine-set up ang mga provider sa deploy",
  stats: {
    label: "Buod ng AI platform (huling 30 araw)",
    llmSpend: "Gastos sa LLM (30a)",
    llmSpendFoot: "≈ {{php}} · lahat ng AI {{total}}",
    perDay: "Mensahe / araw",
    perDayFoot: "{{conversations}} usapan sa loob ng 30 araw",
    cacheHit: "Cache hit rate",
    cacheHitFoot: "natipid ≈ {{saved}} (30a)",
    providers: "Naka-enable na provider",
    providersFoot: "{{count}} gumagana",
  },
  tabs: {
    label: "Mga seksyon ng AI platform",
    providers: "Mga provider",
    chat: "Mga chat model",
    embeddings: "Embeddings",
    rerankers: "Rerankers",
    guardrails: "Guardrails at moderation",
    cache: "Semantic cache",
  },
  status: { operational: "Gumagana", degraded: "Mabagal", down: "Down", unknown: "Hindi alam" },
  kinds: { chat: "Chat", embedding: "Embeddings", rerank: "Rerank", vision: "Vision" },
  providers: {
    callout: "Dumadaan ang lahat ng tawag sa Sagot LLM gateway. Nasa deployment secret store ang mga provider key at hindi ipinapadala sa tenant — naka-mask na status lang ang ipinapakita rito.",
    listLabel: "Mga AI provider",
    enable: "I-enable ang {{name}} para sa routing",
    enabled: "Naka-enable na ang {{name}} para sa routing",
    disabled: "Naka-disable ang {{name}} — lilipat ang traffic sa fallbacks",
    statusLabel: "Status",
    apiKey: "API key",
    notConfigured: "Hindi naka-configure",
    rotate: "Rotate",
    rotateFor: "Rotate ang key ng {{name}}",
    rotated: "Na-rotate {{when}} · susunod sa {{due}}",
    rotatedNoDue: "Na-rotate {{when}}",
    neverRotated: "Wala pang naitalang rotation",
    region: "Rehiyon",
    models: "Mga model",
    modelCount_one: "{{count}} model",
    modelCount_other: "{{count}} model",
    modelList: "Mga model: {{list}}",
    noModels: "Walang nakarehistrong model",
    test: "Subukan ang koneksyon",
    testUnavailable: "Hindi pa available ang pag-test ng koneksyon",
    noCapabilities: "Walang model",
    emptyTitle: "Walang naka-configure na provider",
    emptyBody: "Nirerehistro ang mga provider kapag na-deploy ang gateway. Tingnan ang deployment configuration.",
    disableTitle: "I-disable ang {{name}}?",
    disableBody: "Lilipat sa susunod na model sa bawat fallback chain ang mga request na papunta sa {{name}}. Maaaring bumagal o pumalya ang sagot ng mga tenant na naka-pin sa mga model nito.",
    disableConfirm: "I-disable ang provider",
  },
  rotate: {
    title: "Rotate key · {{name}}",
    description: "Palitan muna ang key sa deployment secret store, saka itala ang rotation dito. Huling 4 na character lang ang sine-save ng Sagot.",
    last4: "Huling 4 na character ng bagong key",
    last4Hint: "Letra at numero lang, hal. a91F.",
    last4Invalid: "Maglagay ng eksaktong 4 na letra o numero.",
    note: "Tala (opsyonal)",
    notePlaceholder: "hal. Nakaiskedyul na quarterly rotation",
    warning: "Itinatala bilang api_key.rotated. Hindi kailanman ipinapakita o sine-save ng Sagot ang buong key.",
    submit: "Rotate key",
    done: "Naitala ang key rotation para sa {{name}}",
  },
  chat: {
    title: "Mga chat model",
    hint: "Presyo kada 1M token (USD). Kinokontrol ng plan access kung aling model ang mapipili ng tenant sa agent settings.",
    tableLabel: "Mga chat model",
    model: "Model",
    provider: "Provider",
    context: "Context",
    input: "Input / 1M",
    output: "Output / 1M",
    enabledCol: "Naka-enable",
    actionsCol: "Default",
    default: "Default",
    disabledBadge: "Naka-disable",
    makeDefault: "Gawing default",
    makeDefaultFor: "Gawing default ang {{name}}",
    madeDefault: "Ang {{name}} na ang default ng platform",
    enableModel: "I-enable ang {{name}}",
    modelEnabled: "Naka-enable ang {{name}}",
    modelDisabled: "Naka-disable ang {{name}}",
    accessFor: "Access ng {{plan}} sa {{model}}",
    saveAccess: "I-save ang access",
    accessSaved_one: "Na-save ang plan access ng {{count}} model",
    accessSaved_other: "Na-save ang plan access ng {{count}} model",
    noChanges: "Walang babaguhin",
    addModel: "Magdagdag ng model",
    emptyTitle: "Wala pang chat model",
    emptyBody: "Magrehistro ng provider model para magamit sa routing at mga plan.",
  },
  routing: {
    title: "Mga routing chain",
    hint: "Sinusubukan ng bawat routing key ang mga model nito mula itaas pababa. Nagfa-fallback ang gateway kapag timeout, rate limit (429) o error ng provider (5xx).",
    listLabel: "Mga routing key",
    edit: "I-edit",
    editing: "Ine-edit",
    steps_one: "{{count}} model",
    steps_other: "{{count}} model",
    orderTitle: "Pagkakasunod ng fallback",
    orderHint: "Gamitin ang mga arrow para ayusin. Ang una ang primary.",
    orderFor: "Pagkakasunod ng fallback para sa {{key}}",
    primary: "Primary",
    fallback: "Fallback {{n}}",
    moveUp: "Itaas ang {{name}}",
    moveDown: "Ibaba ang {{name}}",
    remove: "Alisin ang {{name}}",
    addLabel: "Magdagdag ng model sa chain",
    addPlaceholder: "Pumili ng model…",
    add: "Idagdag",
    save: "I-save ang routing",
    saved: "Na-save ang routing para sa {{key}} · itinala bilang model.routing.updated",
    reset: "I-reset",
    unsaved: "May hindi pa na-save",
    maxSteps: "Hanggang {{count}} model lang ang isang chain.",
    disabledModel: "Naka-disable",
    emptyTitle: "Walang routing key",
    emptyBody: "Ginagawa ang mga routing key ng gateway seed. Tingnan ang deployment.",
  },
  models: {
    title: "Magdagdag ng model",
    description: "Magrehistro ng provider model. Naka-disable ang bagong model maliban kung i-enable mo ngayon.",
    provider: "Provider",
    kind: "Uri",
    displayName: "Pangalang ipapakita",
    modelKey: "Model key",
    modelKeyHint: "Ang model id ng provider, hal. gpt-5-mini.",
    modelKeyInvalid: "Gumamit ng letra, numero, tuldok, gitling, @ o underscore (max 80).",
    tier: "Tier",
    tierNone: "Walang tier",
    tiers: { standard: "Standard", premium: "Premium" },
    context: "Context window (token)",
    dimensions: "Dimensions",
    inputPrice: "Input / 1M (USD)",
    outputPrice: "Output / 1M (USD)",
    numberInvalid: "Maglagay ng positibong numero.",
    nameRequired: "Maglagay ng pangalan.",
    providerRequired: "Pumili ng provider.",
    enableNow: "I-enable ngayon",
    enableNowHint: "Kung hindi, naka-disable ang model paggawa.",
    submit: "Idagdag ang model",
    done: "Naidagdag ang {{name}}",
  },
  embeddings: {
    defaultTitle: "Default na embedding model",
    inRouting: "Primary sa routing",
    noDefaultTitle: "Walang default na embedding model",
    noDefaultBody: "Magdagdag ng embedding model at ilagay ito sa unahan ng embedding routing chain.",
    dims: "@{{dims}}d",
    dimensions: "Dimensions",
    cost: "Gastos",
    perMillion: "/ 1M tok",
    provider: "Provider",
    verified: "Na-verify ang presyo",
    pipelineTitle: "Ingestion pipeline",
    pipeline: {
      parse: "Parse + OCR (layout, table, heading)",
      chunk: "Chunking na sumusunod sa istruktura, may overlap",
      context: "Contextual retrieval: maliit na model ang sumusulat ng context kada chunk",
      embed: "Embed → vector column + full-text index",
    },
    alternativesTitle: "Mga alternatibo",
    alternativesEmptyTitle: "Walang alternatibong model",
    alternativesEmptyBody: "Magrehistro ng ibang embedding model para ikumpara o ilipat dito ang mga tenant.",
    migrate: "Ilipat ang isang tenant",
    altMeta: "{{provider}} · {{dims}}",
    altDisabled: "Naka-disable",
  },
  migrations: {
    title: "Re-embed migration",
    hint: "Hindi maikukumpara ang mga vector mula sa magkaibang model, kaya ang paglipat ng model ay nangangahulugang re-embed ng bawat chunk ng tenant sa bagong index.",
    new: "Bagong migration",
    steps: {
      shadow: { title: "Gumawa ng shadow column + index", body: "Binubuo nang sabay sa live index" },
      backfill: { title: "Backfill gamit ang embedding workers", body: "Ginagamit ulit ang naka-save na chunk text; dual-write ang bagong upload" },
      evaluate: { title: "Patakbuhin ang golden-set evaluation", body: "Hinaharang ang cutover kapag bumaba ang recall" },
      cutover: { title: "Atomic cutover, itago ang lumang index", body: "Ang rollback ay pagpapalit ng embedding version ng tenant" },
    },
    listLabel: "Mga migration job",
    allTenants: "Lahat ng tenant",
    unknownTenant: "Hindi kilalang tenant",
    unknownModel: "Hindi kilalang model",
    jobTitle: "{{tenant}} → {{model}}",
    jobMeta: "job {{id}} · ginawa {{when}}",
    progress: "{{done}} / {{total}} chunk",
    progressLabel: "Progreso ng re-embed para sa {{tenant}}",
    dimensions: "Dimensions",
    started: "Nagsimula",
    estCost: "Tantiyang gastos",
    notStarted: "Hindi pa nagsisimula",
    states: { queued: "Nakapila", running: "Tumatakbo", paused: "Naka-pause", cancelled: "Kinansela", done: "Tapos", failed: "Pumalya" },
    pause: "I-pause",
    resume: "Ituloy",
    cancel: "Kanselahin at i-drop ang shadow index",
    paused: "Naka-pause ang migration · tatapusin ng workers ang kasalukuyang batch",
    resumed: "Itinuloy ang migration",
    cancelled: "Kinansela ang migration · na-drop ang shadow index",
    viewQueue: "Tingnan ang queue",
    emptyTitle: "Walang re-embed migration",
    emptyBody: "Magsimula ng isa para ilipat ang isang tenant (o lahat) sa ibang embedding model.",
    cancelTitle: "Kanselahin ang migration?",
    cancelBody: "Mada-drop ang {{done}} na na-re-embed na chunk at ang shadow index. Mananatili ang {{tenant}} sa kasalukuyang model. Hindi na mababawi ang nagastos na embedding.",
    keepRunning: "Ituloy lang",
    cancelConfirm: "Kanselahin ang migration",
    dialogTitle: "Bagong re-embed migration",
    dialogDescription: "Ipinipila ang job sa embedding workers. Sasagot pa rin ang mga tenant mula sa kasalukuyang index hanggang sa cutover.",
    tenant: "Tenant",
    target: "Target na model",
    targetRequired: "Pumili ng embedding model.",
    noTargets: "Magrehistro muna ng embedding model.",
    runWindow: "Oras ng pagtakbo",
    windows: { now: "Ngayon", off_peak: "Off-peak mamayang gabi (11 PM – 5 AM PHT)" },
    evalGate: "Patakbuhin ang golden-set eval at harangin ang cutover kapag bumaba ang recall",
    notifyOwner: "Abisuhan ang may-ari ng tenant kapag tapos na",
    submit: "Ipila ang migration",
    queued: "Nakapila ang migration · {{chunks}} chunk",
  },
  rerankers: {
    pipelineTitle: "Retrieval pipeline",
    pipelineLabel: "Mga hakbang ng retrieval pipeline",
    query: "Tanong ng user",
    vector: "Vector search · top {{n}}",
    fts: "Full-text search · top {{n}}",
    fusion: "RRF fusion",
    rerank: "Cross-encoder rerank",
    topN: "Top {{n}} → LLM (SSE)",
    primary: "Primary",
    fallback: "Fallback",
    primaryBody: "Unang reranker sa rerank routing chain. Dito dumadaan ang bawat retrieval maliban kung mag-failover.",
    fallbackBody: "Awtomatikong ginagamit kapag hindi maayos, naka-drain, o lumampas sa threshold sa ibaba ang p95 ng primary.",
    noFallback: "Walang fallback reranker sa chain",
    noReranker: "Walang naka-configure na reranker",
    maxBatch: "Max batch (pairs)",
    failover: "Mag-failover kapag primary p95 >",
    ms: "{{value}} ms",
    settingsTitle: "Mga setting ng candidate at top-N",
    candidates: "Candidate kada retriever",
    candidatesHint: "Ganito karami ang ibinabalik ng vector at full-text search bago ang fusion.",
    topNLabel: "Top-N pagkatapos ng rerank",
    topNHint: "Mga chunk na isinasama sa prompt.",
    minRelevance: "Minimum na relevance score",
    minRelevanceHint: "Kapag mas mababa rito, sasabihin ng agent na hindi niya alam at itatala ang knowledge gap.",
    save: "I-save",
    saved: "Na-save ang retrieval settings · para sa mga bagong request",
  },
  guardrails: {
    injectionTitle: "Prompt-injection classifier",
    injectionBody: "Sinusuri ang mensahe ng user at mga web-crawl chunk para sa utos tulad ng \"ignore previous instructions\".",
    injectionToggle: "Naka-enable ang prompt-injection classifier",
    threshold: "Threshold ng pag-block",
    action: "Aksyon",
    actions: { block: "I-block at sumagot ng ligtas na mensahe", flag: "I-flag lang (itala sa traces)" },
    piiTitle: "PII detector",
    piiBody: "Nire-redact ang personal na data sa naka-save na transcript at traces (Data Privacy Act 2012).",
    piiToggle: "Naka-enable ang PII detector",
    entitiesLabel: "Mga PII entity na ire-redact",
    entities: {
      ph_mobile: "PH mobile (09xx)",
      email: "Email",
      tin: "TIN",
      sss_gsis: "SSS / GSIS",
      philhealth: "PhilHealth",
      lrn: "LRN",
      home_address: "Address ng bahay",
      card_number: "Numero ng card",
    },
    mask: "I-mask din bago ipadala sa LLM",
    moderationTitle: "Moderation",
    moderationBody: "Kina-classify ang input at output kada kategorya. Mas mahigpit ang mas mababang threshold.",
    moderationToggle: "Naka-enable ang moderation",
    categories: { self_harm: "Self-harm", sexual_minors: "Sexual / menor de edad", harassment: "Harassment", violence: "Karahasan" },
    hotline: "Sa self-harm, ipinapakita ang PH hotline (NCMH 1553) at inaabisuhan ang handoff team ng tenant.",
    saveTitle: "Mga setting ng guardrail",
    saveHint: "Ilalapat ang mga threshold sa mga bagong request sa lahat ng tenant.",
    save: "I-save lahat",
    saved: "Na-save ang guardrail thresholds · itinala bilang guardrails.updated",
  },
  cache: {
    title: "Semantic cache",
    hint: "Naka-key kada tenant + agent + audience · ginagamit ulit ang sagot kapag walang nagbagong source",
    toggle: "Naka-enable ang semantic cache",
    similarity: "Similarity threshold",
    similarityHint: "Cosine similarity ng query embedding. Mas mababa = mas maraming hit, mas malaking tsansang mali ang magamit ulit.",
    ttl: "TTL",
    ttlHint: "Binubura rin ang entry kapag na-re-ingest ang alinmang source na binanggit.",
    ttls: { "6": "6 na oras", "24": "24 na oras", "168": "7 araw" },
    skip: "Laktawan ang cache sa personalised na sagot (naka-sign-in na user, tool call)",
    save: "I-save",
    saved: "Na-save ang cache settings",
    purge: "I-purge ang cache…",
    statsTitle: "Stats ng cache",
    hitRateLabel: "Cache hit rate (30 araw)",
    hitRate: "Hit rate (30a)",
    hits: "Hits",
    entries: "Entries",
    saved30: "Natipid (30a)",
    topTitle: "Pinakamadalas na naka-cache na tanong",
    topItem: "{{question}} · {{tenant}}",
    topEmpty: "Wala pang naka-cache na tanong.",
    purgeTitle: "I-purge ang semantic cache?",
    purgeBody: "Mabubura ang mga naka-cache na sagot. Asahan ang mas mataas na latency at gastos sa LLM habang umiinit ulit ang cache.",
    scope: "Saklaw",
    scopeAll: "Lahat ng tenant ({{entries}} entries)",
    scopeTenant: "{{name}} lang",
    purgeLabel: "I-type ang PURGE para kumpirmahin",
    purgeSubmit: "I-purge ang cache",
    purged_one: "Na-purge ang cache · {{count}} entry ang naalis · itinala bilang cache.purged",
    purged_other: "Na-purge ang cache · {{count}} entries ang naalis · itinala bilang cache.purged",
  },
};
